var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170.243,
    height: 170.119,
    viewBox: "0 0 170.243 170.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1395.963 -3228)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1395.963 3228)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.183,0A85.059,85.059,0,1,1,0,85.059,85.194,85.194,0,0,1,85.183,0Z",
    transform: "translate(0)",
    fill: "#ffcd28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.937,28.762a79.435,79.435,0,0,1,1.1,13.339,85.127,85.127,0,0,1-77.716,84.816L0,84.323c0-1.956,1.348-2.81,1.348-4.648V1.1H91.425L95.831,0c1.591,2.446,35.614,28.762,36.105,28.762Z",
    transform: "translate(37.205 42.959)",
    fill: "#d4a60b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.752,15.423H90.079V78.574H5.752Zm90.08,63.151v5.749H0V0H95.832V78.574Z",
    transform: "translate(37.205 42.959)",
    fill: "#324a5e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.908A3.84,3.84,0,0,0,3.918,7.7a3.812,3.812,0,0,0,3.793-3.8A3.856,3.856,0,1,0,0,3.908Z",
    transform: "translate(109.048 46.756)",
    fill: "#90dfaa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.908A3.841,3.841,0,0,0,3.918,7.7a3.81,3.81,0,0,0,3.793-3.8A3.856,3.856,0,1,0,0,3.908Z",
    transform: "translate(119.573 46.756)",
    fill: "#ffd05b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.908A3.809,3.809,0,0,0,3.793,7.7,3.853,3.853,0,1,0,0,3.908Z",
    transform: "translate(98.524 46.756)",
    fill: "#fd8469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H84.328V63.151H0Z",
    transform: "translate(42.957 58.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.329,7.468H3.3V61.074H37.329ZM22.643,65.111a2.329,2.329,0,1,0-4.652,0,2.326,2.326,0,1,0,4.652,0ZM14.81,3.918a.561.561,0,0,0,.49.611H25.338a.56.56,0,0,0,.486-.611c0-.243-.243-.611-.486-.611H15.3C15.055,3.307,14.81,3.675,14.81,3.918Zm25.825.733V65.11a4.753,4.753,0,0,1-4.774,4.651H4.774A4.752,4.752,0,0,1,0,65.11V4.651A4.757,4.757,0,0,1,4.774,0H35.86A4.758,4.758,0,0,1,40.635,4.651Z",
    transform: "translate(104.763 71.596)",
    fill: "#253645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H34.759V54.957H0Z",
    transform: "translate(107.702 78.327)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.326,0A2.353,2.353,0,0,0,0,2.446a2.326,2.326,0,1,0,4.652,0A2.353,2.353,0,0,0,2.326,0Z",
    transform: "translate(122.755 134.261)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.49,1.223H10.529a.56.56,0,0,0,.486-.611c0-.243-.243-.611-.486-.611H.49C.245,0,0,.368,0,.611A.561.561,0,0,0,.49,1.223Z",
    transform: "translate(119.573 74.902)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.a859a5dd9634a75ef446301e96bba139.svg";
export { ForwardRef as ReactComponent };